/**
 * Tiny token store + helpers. Tokens live in localStorage so the page can
 * survive reload; on logout we wipe everything.
 */

export interface SessionUser {
  id: string;
  email: string;
  role: "superadmin" | "admin" | "staff";
  companyId: string | null;
  name: string;
}

const KEY = "am.session";

export interface Session {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  user: SessionUser;
}

export function loadSession(): Session | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Session;
  } catch {
    return null;
  }
}

export function saveSession(s: Session): void {
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
}
